import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { DynamicFormWrapper } from 'remote-com-shared/components/ModalForm/styles';
import { fluidProp, whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { fromTabletBreakpoint, tabletBreakpoint } from '@/src/domains/shared/breakpoints';

export const SectionWrapper = styled.div`
  ${fluidProp(['padding-top', 'padding-bottom'], '80px', '140px')}
  --titleColor: inherit;
  --textColor: var(--colors-lynch);
  position: relative;

  ${({ $tone }) => {
    switch ($tone) {
      case 'light':
        return css`
          background-color: var(--colors-blank);
        `;
      case 'purpleMinsk':
        return css`
          background-image: var(--colors-purpleMinsk);
        `;
      default:
        return css`
          background: var(--colors-zircon);
          background-attachment: fixed;
        `;
    }
  }}
`;

const SectionCenteredContent = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const SectionHeader = styled.header`
  ${SectionCenteredContent}
`;

export const SectionTitle = styled.div`
  ${fluidProp('font-size', '24px', '36px')}
  line-height: 1.2em;
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 20px;

  ${whenProp(
    '$centered',
    css`
      text-align: center;
    `
  )}

  ${({ $tone }) => {
    switch ($tone) {
      case 'light':
        return css`
          color: var(--colors-blank);
        `;
      default:
        return css`
          color: var(--colors-darkBlue);
        `;
    }
  }}

  * {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const Description = styled.div`
  font-size: 18px;
  line-height: 1.4em;
  margin-top: 24px;

  ${({ $tone }) => {
    switch ($tone) {
      case 'dark':
        return css`
          color: var(--colors-bayoux);
        `;
      case 'light':
        return css`
          color: var(--colors-moonRaker);
        `;
      default:
        return css`
          color: var(--textColor);
        `;
    }
  }}

  > * {
    font-size: inherit;
    line-height: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const SectionDescription = styled(Description)`
  text-align: center;
`;

export const FormWrapper = styled.div`
  margin-top: -260px;
  z-index: 1;
`;

export const GatedContentSectionWrapper = styled(SectionWrapper)`
  --textColor: var(--colors-spindle);
  background: var(--colors-zircon);

  ${ContentContainer} {
    display: grid;
    gap: 50px;

    ${tabletBreakpoint(css`
      grid-template-rows: 1fr min-content;
    `)}
    ${fromTabletBreakpoint(css`
      grid-template-columns: 1fr 1fr;
    `)}
  }
  ${Description} {
    ${tabletBreakpoint(css`
      padding-bottom: 250px;
    `)}
  }
`;

export const MainContent = styled.div`
  ${SectionTitle} {
    margin-bottom: 30px;
  }
`;

export const IconShieldWrapper = styled.span`
  height: 80px;
  width: 80px;
  border-radius: 25px;
  background-color: var(--colors-selago);
  color: var(--colors-irisBlue);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  & > svg {
    height: 30px;
    width: auto;
  }
`;

export const GDPRFormWrapper = styled(DynamicFormWrapper)`
  --dynamicFormContainerMargin: 0 0 80px;
  padding-top: 0;
`;
